// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"E0kRQxfV"};